<template>
  <div class="linkable" @click="$emit('click')">
    <img
      src="/clientV2/static/gfx/ArrowCircle.svg"
      class="iconBtn transition"
      :class="{'opened': open === true}"
    >
    {{(open === false) ? showText : hideText}}
  </div>
</template>

<script>
export default {
  name: "UiMoreButton",
  props: ["open", "showText", "hideText"],
  data() {
    return {};
  },
  methods: {
    update() {
      this.$emit("change", this.value);
    }
  }
};
</script>

<style scoped lang="less">
@import "../../assets/css/style.less";

div {
  display: block;
  width: 230px;
  margin: 8px 15px 0px;
  cursor: pointer;
}

img {
  margin-left: 8px;
  margin-top: -4px;
  display: inline-block;
  vertical-align: middle;
  transform: rotate(90deg);
}

.opened {
  transform: rotate(0);
}
</style>



// WEBPACK FOOTER //
// src/components/ui/uiMoreButton.vue